import React, { useCallback } from 'react';
import TagBox, { TagBoxTypes } from 'devextreme-react/tag-box';

const nameLabel = { 'aria-label': 'Name' };

export const EmployeeTagBoxComponent = (props) => {
  const onValueChanged = useCallback((e: TagBoxTypes.ValueChangedEvent) => {
    props.data.setValue(e.value);
  }, [props]);

  const onSelectionChanged = useCallback(() => {
    props.data.component.updateDimensions();
  }, [props]);

  return (
    <TagBox
      dataSource={props.data.column.lookup.dataSource}
      defaultValue={props.data.value}
      valueExpr='Oid'
      displayExpr='FullName'
      showSelectionControls
      maxDisplayedTags={3}
      inputAttr={nameLabel}
      showMultiTagOnly={false}
      applyValueMode='useButtons'
      searchEnabled
      onValueChanged={onValueChanged}
      onSelectionChanged={onSelectionChanged} />
  );
};
